import { ConfirmationDialog } from "../../../assets/types/common";
import { Constants } from "../../../assets/utils/lib/constants";
import Drawer from "../../../assets/vfx/drawer/drawer";
import { LoadingIndicator } from "../../../assets/vfx/loadingIndicator/vfxLoadingIndicator";
import DisplayData from "../../common/DisplayData/DisplayData";
import { ViewProps } from "../props";

interface LookupTypeViewProps<T> {
    data: T | undefined;
    show: boolean;
    onHide: () => void;
    onEdit: () => void;
    onDelete: () => void;
    isLoading: boolean;
}

export const LookupTypeView = <T extends ViewProps.CategoryTypeDto,>(props: LookupTypeViewProps<T>) => {

    return (
        <Drawer.View
            className="w-30"
            show={props.show}
            backdrop={true}
            placement="end"
            scroll={true}
            onHide={() => props.onHide()}
            onEdit={props.isLoading ? undefined : props.onEdit}
            title="View Lookup Category"
            onDelete={(props.isLoading || props.onDelete === undefined) ? undefined : props.onDelete}
            modalDialogProps={props.onDelete === undefined ? undefined : new ConfirmationDialog().get(props.onDelete, "Delete", { "Name": props?.data?.name ?? Constants.emptyString })}
        >
            {props.isLoading ? (
                <LoadingIndicator isFullPage={true} />
            ) : (
                <>
                    <DisplayData text="Name" importedData={props.data?.name ?? Constants.emptyString} />
                    <DisplayData text="Description" importedData={props.data?.description ?? Constants.emptyString} />
                </>
            )}
        </Drawer.View>
    );
}